import React from 'react'
import StatusBadge from '../components/StatusBadge/StatusBadge'
import CellAssetName from '../components/Table/components/CellAssetName'
import CellLocation from '../components/Table/components/CellLocation'
import UserStatusBadge from '../components/UserStatusBadge/UserStatusBadge'
import AppRoutes from '../routes/appRoutes'
import { formatPhoneNumberLocalUS, isActive, wasInvited } from './util'
import moment from 'moment'
import CellRequestNumber from '../components/Table/components/CellRequestNumber'
import CellUserName from '../components/Table/components/CellUserName'

export const fleetColumns = [
    {
        field: 'assetName',
        value: 'Customer Unit #',
    },
    {
        field: 'serialNumber',
        value: 'Serial Number',
    },
    {
        field: 'equipmentNumber',
        value: 'Equipment Number',
    },
    {
        field: 'make',
        value: 'Make',
    },
    {
        field: 'ownership',
        value: 'Ownership',
    },
    {
        field: 'location',
        value: 'Location',
    },
]

export const fleetColumnsFromRequest = [
    {
        field: 'assetName',
        value: 'Customer Unit #',
    },
    {
        field: 'serialNumber',
        value: 'Serial Number',
    },
    {
        field: 'equipmentNumber',
        value: 'Equipment Number',
    },
    {
        field: 'make',
        value: 'Make',
    },
    {
        field: 'location',
        value: 'Location',
    },
]

export const formatFleetOnRequest = fleet => {
    return fleet.map(item => {
        return {
            ...item,
            assetName: (
                <CellAssetName
                    isTitle
                    assetName={
                        item.customerAlias ? item.customerAlias : item.name
                    }
                    to={`${AppRoutes.fleetAsset(
                        item?.salesforceID,
                    )}?activeTab=overviewTab`}
                />
            ),
            assetNameKey: item.customerAlias
                ? item.customerAlias
                : item.name || '-',
            serialNumber: item?.serialLotNumber,
            equipmentNumber: item?.equipmentNumber,
            make:
                item.manufacturer != 'Other'
                    ? `${item?.manufacturer} ${item?.simpleType || ''}`
                    : item?.simpleType || '-',
            makeKey:
                item.manufacturer != 'Other'
                    ? `${item?.manufacturer} ${item?.simpleType || ''}`
                    : item?.simpleType || '-',
            location: (
                <CellLocation
                    label={item?.shippingName}
                    address={item?.shippingAddress}
                />
            ),
            locationKey: item?.shippingAddress || '-',
            fleetName: item?.shippingName,
            fleetAddress: item?.shippingAddress,
            shipToSalesforceId: item?.shipTo?.salesforceID,
        }
    })
}

export const getAssetsList = fleets => {
    let assetsLists = []
    Object.keys(fleets).forEach(key => {
        const fleet = fleets[key]
        fleet?.assets?.forEach(item => assetsLists.push(item))
    })
    return assetsLists
}

export const fleetExportDataTittles = [
    {
        assetName: 'Asset Name',
        serialNumber: 'Serial Number',
        equipmentNumber: 'Equipment Number',
        make: 'Make',
        ownership: 'Ownership',
        location: 'Location',
        address: 'Address',
    },
]

const formatExportInfo = equipment => {
    return {
        assetName: equipment.customerAlias
            ? equipment.customerAlias
            : equipment.name,
        serialNumber: equipment?.serialLotNumber,
        equipmentNumber: equipment?.equipmentNumber,
        make:
            equipment.manufacturer != 'Other'
                ? `${equipment?.manufacturer} ${equipment?.simpleType}`
                : equipment?.simpleType,
        ownership: equipment?.categoryType,
        location: equipment?.shippingName,
        address: equipment?.shippingAddress,
    }
}

export const formatFleetExport = fleets => {
    let assetsLists = []

    Object.keys(fleets).forEach(key => {
        const fleet = fleets[key]
        const assetsListFormatted =
            fleet?.assets?.map(equipment => {
                return formatExportInfo(equipment, fleet?.name, fleet?.address)
            }) || []

        assetsListFormatted?.forEach(item => assetsLists.push(item))
    })

    return assetsLists
}

export const formatDashboardExport = fleet => {
    return fleet?.map(equipment => {
        return formatExportInfo(equipment)
    })
}

export const formatFleetRows = fleet => {
    return fleet.map(item => {
        return {
            ...item,
            assetName: (
                <CellAssetName
                    isTitle
                    isLink
                    assetName={
                        item.customerAlias ? item.customerAlias : item.name
                    }
                    to={`${AppRoutes.fleetAsset(
                        item?.salesforceID,
                    )}?activeTab=overviewTab`}
                />
            ),
            assetNameKey: item.customerAlias
                ? item.customerAlias
                : item.name || '-',
            serialNumber: item?.serialLotNumber,
            equipmentNumber: item?.equipmentNumber,
            make:
                item.manufacturer != 'Other'
                    ? `${item?.manufacturer} ${item?.simpleType || ''}`
                    : item?.simpleType || '-',
            makeKey:
                item.manufacturer != 'Other'
                    ? `${item?.manufacturer} ${item?.simpleType || ''}`
                    : item?.simpleType || '-',
            ownership: item?.categoryType,
            location: (
                <CellLocation
                    label={item?.shippingName}
                    address={item?.shippingAddress}
                />
            ),
            locationKey: item?.shippingAddress || '-',
            fleetName: item?.shippingName,
            fleetAddress: item?.shippingAddress,
            shipToSalesforceId: item?.shipTo?.salesforceID,
        }
    })
}

export const formatAssetList = (assets = []) => {
    return assets?.map(item => {
        return {
            ...item,
            assetName: (
                <CellAssetName
                    isTitle
                    isLink
                    assetName={
                        item.customerAlias ? item.customerAlias : item.name
                    }
                    to={`${AppRoutes.fleetAsset(
                        item?.salesforceID,
                    )}?activeTab=overviewTab`}
                />
            ),
            assetNameKey: item.customerAlias
                ? item.customerAlias
                : item.name || '-',
            serialNumber: item?.serialLotNumber,
            equipmentNumber: item?.equipmentNumber,
            make:
                item.manufacturer != 'Other'
                    ? `${item?.manufacturer} ${item?.simpleType || ''}`
                    : item?.simpleType || '-',
            makeKey:
                item.manufacturer != 'Other'
                    ? `${item?.manufacturer} ${item?.simpleType || ''}`
                    : item?.simpleType || '-',
            ownership: item?.categoryType,
            location: (
                <CellLocation
                    label={item?.shippingName}
                    address={item?.shippingAddress}
                />
            ),
            locationKey: item?.shippingAddress || '-',
            fleetName: item?.shippingName,
            fleetAddress: item?.shippingAddress,
        }
    })
}

export const usersCols = [
    {
        field: 'userName',
        value: 'Name',
    },
    {
        field: 'status',
        value: 'Status',
    },
    {
        field: 'email',
        value: 'Email',
    },
    {
        field: 'phone',
        value: 'Phone Number',
    },
    {
        field: 'location',
        value: 'Location',
    },
]

const formatUserRow = (user, loggedUserId) => {
    const isYou = user?.id === loggedUserId
    const statusBadge = isYou
        ? 'You'
        : isActive(user)
        ? 'Activated'
        : wasInvited(user)
        ? 'Invited'
        : 'Not Invited'

    const name = user?.first_name + ' ' + user?.last_name

    return {
        ...user,
        userName: user?.first_name ? <CellUserName userName={name} /> : '-',
        userNameKey: user?.first_name || '-',
        status: <UserStatusBadge status={statusBadge} />,
        statusKey: statusBadge || '-',
        email: user?.email,
        phone: formatPhoneNumberLocalUS(user?.phone) || '-',
        phoneKey: user?.phone || '-',
        location: user.shipping_name ? (
            <CellLocation
                label={user?.shipping_name}
                address={user?.shipping_address}
            />
        ) : (
            '-'
        ),
        locationKey: user?.shipping_address || '-',
    }
}
// Change it to see the logged in user first
export const formatUsersRows = (data, user) => {
    let usersList = []
    let first = [formatUserRow(user, user.id)]

    usersList = data?.map(userItem => {
        const isYou = Number(userItem?.id) === Number(user.id)
        if (!isYou) {
            return formatUserRow(userItem, user.id)
        }
    })

    return first.concat(usersList.filter(el => el !== undefined))
}

export const serviceHistoryCols = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'type',
        value: 'Type',
    },
    {
        field: 'status',
        value: 'Status',
    },
    {
        field: 'submittedOn',
        value: 'Submitted On',
    },
    {
        field: 'submittedBy',
        value: 'Submitted By',
    },
    {
        field: 'details',
        value: 'Details',
    },
]

export const serviceHistoryColsMobile = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'status',
        value: 'Status',
    },
    {
        field: 'type',
        value: 'Type',
    },
    {
        field: 'submittedOn',
        value: 'Submitted On',
    },
    {
        field: 'submittedBy',
        value: 'Submitted By',
    },
    {
        field: 'details',
        value: 'Details',
    },
]

export const formatServiceHistoryRows = requests => {
    return requests?.map(request => {
        return {
            ...request,
            requestNumber: (
                <CellRequestNumber
                    to={AppRoutes.viewServiceRequest(request?.id)}
                    number={request?.name}
                    translate="translate(95%, -420%)"
                />
            ),
            requestNumberKey: request?.name || '-',
            type: request?.type || '-',
            status: request?.status ? (
                <StatusBadge
                    displayClass={request?.status}
                    statusDescription={request?.statusDescription}
                />
            ) : (
                '-'
            ),
            statusKey: request?.status || '-',
            submittedOn: request?.prettyDate ? (
                <CellAssetName assetName={request?.prettyDate} />
            ) : (
                '-'
            ),
            submittedOnKey: request?.submittedDate || '-',
            submittedBy: request?.userName || '-',
            details: request?.description || '-',
        }
    })
}

export const plannedMaintenanceCols = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'submittedOn',
        value: 'Created On',
    },
]

export const formatPlannedMaintenance = requests => {
    return requests?.map(request => {
        return {
            ...request,
            requestNumber: (
                <CellRequestNumber
                    to={AppRoutes.viewPlannedMaintenance(request?.id)}
                    number={request?.name}
                    translate="translate(95%, -420%)"
                />
            ),
            requestNumberKey: request?.name || '-',
            statusC: request?.status ? (
                <StatusBadge
                    displayClass={request?.status}
                    statusDescription={request?.statusDescription}
                />
            ) : (
                '-'
            ),
            statusCKey: request?.status || '-',
            submittedOn: request?.prettyDate || '-',
        }
    })
}

export const requestsTableCols = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'type',
        value: 'Type',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'submittedOn',
        value: 'Submitted On',
    },
    {
        field: 'assetNameNormal',
        value: 'Customer Unit #',
    },
    {
        field: 'location',
        value: 'Location',
    },
]

export const requestsTableColsMobile = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'type',
        value: 'Type',
    },
    {
        field: 'submittedOn',
        value: 'Submitted On',
    },
    {
        field: 'assetNameNormal',
        value: 'Customer Unit #',
    },
    {
        field: 'location',
        value: 'Location',
    },
]

export const requestsPMTableCols = [
    {
        field: 'requestNumber',
        value: 'PM Number',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'submittedOn',
        value: 'Created On',
    },
    {
        field: 'assetNameNormal',
        value: 'Customer Unit #',
    },
    {
        field: 'location',
        value: 'Location',
    },
]
export const requestCheckDuplicateCols = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'details',
        value: 'Details',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'submittedOn',
        value: 'Submitted On',
    },
    {
        field: 'submittedBy',
        value: 'Submitted By',
    },
]

export const requestCheckDuplicateColsMobile = [
    {
        field: 'requestNumber',
        value: 'Request Number',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'details',
        value: 'Details',
    },
    {
        field: 'submittedOn',
        value: 'Submitted On',
    },
    {
        field: 'submittedBy',
        value: 'Submitted By',
    },
]

export const formatRequestsListTableCheckDuplicates = (requests, asset) => {
    const equipmentId = asset?.external_id
        ? asset?.external_id
        : asset?.salesforceID
    return requests?.map(request => {
        let link = ''
        const requestId = request?.id
        let translate = 'translate(95%, -420%)'

        switch (request?.showType) {
            case 'Rental':
                link = AppRoutes.viewRentalRequest(requestId)
                break
            case 'Repair':
                link = `${AppRoutes.viewServiceRequest(
                    requestId,
                )}?equipmentId=${equipmentId}`
                translate = 'translate(95%, -350%)'
                break
            case 'Equipment':
                link = AppRoutes.viewSalesRequest(requestId)
                break
            case 'Parts':
                link = AppRoutes.viewPartsRequest(requestId)
                break
            case 'PM':
                link = AppRoutes.viewPlannedMaintenance(requestId)
                translate = 'translate(95%, -380%)'
                break
            default:
                link = `${AppRoutes.viewServiceRequest(
                    requestId,
                )}?equipmentId=${equipmentId}`
        }

        return {
            ...request,
            requestNumber: (
                <CellRequestNumber
                    to={link}
                    number={request?.name || request?.id}
                    translate={translate}
                />
            ),
            requestNumberKey: request?.name || request?.id || '-',
            type: 'Repair',
            statusC: request?.status ? (
                <StatusBadge
                    displayClass={request?.status}
                    statusDescription={request?.statusDescription}
                />
            ) : (
                '-'
            ),
            statusCKey: request?.status || '-',
            submittedOn: request?.submittedDate
                ? moment(request?.submittedDate).format('ll')
                : '-',
            submittedBy: request?.userName,
            details: request?.description,
        }
    })
}

export const formatRequestsListTable = (requests, statusType) => {
    return requests?.map(request => {
        let link = ''
        let translate = 'translate(95%, -420%)'
        const requestId = request?.id
        const requestType = request?.type
        const requestShowType = request?.showType
        const requestStatus = request?.status
        const isRequestType =
            requestType?.includes('PM') ||
            requestType?.includes('Request') ||
            requestType === 'Repair' ||
            requestType === 'Parts'

        const requestAssetName = request?.assetName || request?.customerAlias
        switch (requestShowType) {
            case 'Rental':
                link = AppRoutes.viewRentalRequest(requestId)
                break
            case 'Repair':
                link = AppRoutes.viewServiceRequest(requestId)
                translate = 'translate(95%, -440%)'
                break
            case 'Equipment':
            case 'Used Equipment':
            case 'New Equipment':
                link = AppRoutes.viewSalesRequest(requestId)
                break
            case 'Parts':
                link = AppRoutes.viewPartsRequest(requestId)
                break
            case 'PM':
                link = AppRoutes.viewPlannedMaintenance(requestId)
                translate = 'translate(95%, -380%)'
                break
            default:
                link = AppRoutes.viewServiceRequest(requestId, statusType)
        }

        return {
            ...request,
            requestNumber: (
                <CellRequestNumber
                    to={link}
                    number={request?.label || request?.id}
                    requestType={requestType}
                    requestShowType={requestShowType}
                    requestStatus={requestStatus}
                    translate={translate}
                />
            ),
            requestNumberKey: request?.label || request?.id || '-',
            type: request?.showType,
            statusC: requestStatus ? (
                <StatusBadge
                    displayClass={requestStatus}
                    statusDescription={request?.statusDescription}
                />
            ) : (
                '-'
            ),
            statusCKey: request?.status || '-',
            assetNameNormal: isRequestType ? (
                <CellAssetName assetName={requestAssetName} />
            ) : (
                '-'
            ),
            assetNameNormalKey:
                requestAssetName && isRequestType ? requestAssetName : '-',
            submittedOn: request?.prettyDate ? (
                <CellAssetName assetName={request?.prettyDate} />
            ) : (
                '-'
            ),
            submittedOnKey: request?.submittedDate || '-',
            location: (
                <CellLocation
                    label={request?.shipToName || request?.locationName}
                    address={request?.address}
                />
            ),
            locationKey: request?.address || '-',
        }
    })
}

export const estimateTableCols = [
    {
        field: 'estimateNumber',
        value: 'Estimate Number',
    },
    {
        field: 'statusC',
        value: 'Status',
    },
    {
        field: 'workOrderNumber',
        value: 'Associated Request',
    },
    {
        field: 'details',
        value: 'Details',
    },
    {
        field: 'assetNameNormal',
        value: 'Customer Unit #',
    },
    {
        field: 'createdOn',
        value: 'Created On',
    },
    {
        field: 'validUnitil',
        value: 'Valid Unitil',
    },
]

export const formatEstimateListTable = requests => {
    return requests?.map(request => {
        return {
            ...request,
            estimateNumber: (
                <CellRequestNumber
                    to={AppRoutes.viewEstimateRequest(request?.id)}
                    number={request?.name || request?.id}
                    translate="translate(95%, -450%)"
                />
            ),
            estimateNumberKey: request?.name || request?.id || '-',
            statusC: request?.status ? (
                <StatusBadge displayClass={request?.status} />
            ) : (
                '-'
            ),
            statusCKey: request?.status || '-',
            workOrderNumber: (
                <CellRequestNumber
                    to={AppRoutes.viewServiceRequest(request?.workOrderId)}
                    number={request?.workOrderName || request?.workOrderId}
                    showIcon={false}
                />
            ),
            workOrderNumberKey:
                request?.workOrderName || request?.workOrderId || '-',
            details: request?.estimateDetails ? (
                <CellAssetName assetName={request?.estimateDetails} />
            ) : (
                '-'
            ),
            detailsKey: request?.estimateDetails || '-',
            assetNameNormal: request?.assetName ? (
                <CellAssetName assetName={request?.assetName} />
            ) : (
                '-'
            ),
            assetNameNormalKey: request?.assetName,
            createdOn: request?.submittedPrettyDate ? (
                <CellAssetName assetName={request?.submittedPrettyDate} />
            ) : (
                '-'
            ),
            createdOnKey: request?.submittedDate || '-',
            validUnitil: request?.validUntilPrettyDate ? (
                <CellAssetName assetName={request?.validUntilPrettyDate} />
            ) : (
                '-'
            ),
            validUnitilKey: request?.validUntil || '-',
        }
    })
}

export const assetEstimateTableCols = estimateTableCols.filter(
    col => col.field !== 'assetNameNormal',
)
